var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(-44.5 -144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(44.5 144)",
    fill: "#3f5881"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Phone-2",
    "data-name": "Phone",
    transform: "translate(52.063 151.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M12.282,11.044a1.512,1.512,0,0,0-2.142,0l-.731.731A13.174,13.174,0,0,1,7.136,9.951,13.416,13.416,0,0,1,5.312,7.678l.731-.731a1.512,1.512,0,0,0,0-2.142L4.616,3.384A1.477,1.477,0,0,0,3.553,2.94h0a1.512,1.512,0,0,0-1.073.444l-.685.68A3.21,3.21,0,0,0,.967,6.71a10.68,10.68,0,0,0,3.311,6.078,10.845,10.845,0,0,0,6.1,3.331,3.967,3.967,0,0,0,.423,0,3.059,3.059,0,0,0,2.223-.827l.68-.685a1.512,1.512,0,0,0,.443-1.073,1.477,1.477,0,0,0-.443-1.063Zm.711,2.853-.685.68a2.3,2.3,0,0,1-1.845.5,9.8,9.8,0,0,1-5.448-3.024A9.9,9.9,0,0,1,1.975,6.624a2.283,2.283,0,0,1,.5-1.845l.711-.685a.5.5,0,0,1,.358-.146h0a.5.5,0,0,1,.358.146L5.332,5.536a.5.5,0,0,1,0,.711L4.324,7.254a.5.5,0,0,0-.081.61,13.854,13.854,0,0,0,2.182,2.812,13.854,13.854,0,0,0,2.812,2.182.5.5,0,0,0,.61-.081l1.008-1.008a.5.5,0,0,1,.711,0L12.992,13.2h0a.493.493,0,0,1,0,.7Zm.877-10.684A7.519,7.519,0,0,0,8.527,1a.5.5,0,0,0,0,1.008,6.552,6.552,0,0,1,6.552,6.607.5.5,0,0,0,.5.5h0a.5.5,0,0,0,.5-.5,7.514,7.514,0,0,0-2.218-5.4Z",
    transform: "translate(-0.934 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M18.316,9.23a3.024,3.024,0,0,1,.892,2.172.5.5,0,0,0,.5.5h0a.5.5,0,0,0,.5-.5A4.032,4.032,0,0,0,16.184,7.32a.5.5,0,0,0,0,1.008A3.024,3.024,0,0,1,18.316,9.23Z",
    transform: "translate(-8.249 -4.135)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconBlue);
export default __webpack_public_path__ + "static/media/phoneIconBlue.e4a4a5794f118b419e0772de0a4ae13b.svg";
export { ForwardRef as ReactComponent };